import { render, staticRenderFns } from "./initdata.vue?vue&type=template&id=6bf3741a&scoped=true&"
import script from "./initdata.vue?vue&type=script&lang=js&"
export * from "./initdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3741a",
  null
  
)

export default component.exports